"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.ArrowChevronUp = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 8.00293L4.99902 10.9971C4.52962 10.9971 4.21745 10.7829 4.0625 10.3545C4.02604 10.2588 4.00553 10.1745 4.00098 10.1016V9.99902L8 6L11.999 9.99902V10.1084C11.9626 10.4684 11.7917 10.7305 11.4863 10.8945C11.3496 10.9674 11.1878 11.0016 11.001 10.9971L8 8.00293Z",
    clipRule: "evenodd"
  })));
};